let globalInst = null;
export function register(instance){
    globalInst = instance;
}

/**
 *
 * @returns {DashletsHome}
 */
export default function getDashletHome(){
    return globalInst
}